import { Plugin } from 'prosemirror-state';

import { AddMenuDivider, Divider } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.horizontal_rule.title') as string,
            description: t('Lygo:Menu.horizontal_rule.description') as string,
            icon: Divider,
            addMenuIcon: AddMenuDivider,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['divider', 'horizontal rule', 'line', 'basic'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
